import { memo } from "react";
import { displayAccountLabel } from "@common/helpers/accounting";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { useAccounts } from "@hooks/useAccounts";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import { SplitLedgerInfo } from "../schema";

interface SplitLedgerCellProps {
    row: { original: { ledger: SplitLedgerInfo; entityId: number | null } };
}

export const SplitLedgerCell = memo(({ row }: SplitLedgerCellProps) => {
    const { accountId: ledgerAccountId, accountLabel: ledgerAccountLabel } =
        row.original.ledger ?? {};
    const entityId = row.original.entityId ?? undefined;
    const showAccountNumbers = useShowAccountNumbers();

    const { accountsById } = useAccounts({
        entityId,
        includeDisabled: true,
    });

    const account = ledgerAccountId ? accountsById[ledgerAccountId] : undefined;

    const label = account
        ? displayAccountLabel(account, showAccountNumbers)
        : ledgerAccountLabel;

    if (!label) {
        return (
            <ViewTableCell>
                <EmptyValue />
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell>
            <BreakableText text={label} showTooltip />
        </ViewTableCell>
    );
});

SplitLedgerCell.displayName = "SplitLedgerCell";
